<mat-card
  *ngIf="sequenceState$ | async as sequenceState"
  class="box-shadow border-radius-0 mod-card"
>
  <mat-card-header>
    <mat-card-title class="header-title no-subtitle">
      <mat-icon [inline]="true" class="opacity-4">flight_takeoff</mat-icon>
      Sequence

      <div
        *ngIf="sequenceState.response && sequenceState.response.sequenceNumber"
        matRipple
        class="text-button sequence-number"
        (click)="onSeqTextClick()"
      >
        {{ sequenceState.response.sequenceNumber }}
      </div>

      <div
        *ngIf="!sequenceState.response && !sequenceState.isLoading"
        class="sequence-number"
      >
        Not Found
      </div>

      <app-skeleton
        *ngIf="sequenceState.isLoading && !sequenceState.response"
        width="4rem"
        [inline]="true"
      ></app-skeleton>
    </mat-card-title>
  </mat-card-header>

  <div *ngIf="sequenceState.response as sequence" class="sequence-content">
    <!-- Duty period summary -->
    <div class="day-view-grid-titles label-3">
      <div>Date</div>
      <div>Start</div>
      <div>End</div>
      <div class="text-center">Legs</div>
      <div>Layover</div>
    </div>

    <!-- Duty period loading skeleton -->
    <mat-expansion-panel
      *ngIf="
        sequenceState.isLoading && !sequenceState.response;
        else dutyPeriodPanels
      "
      class="no-shadow"
    >
      <mat-expansion-panel-header class="dp-panel-header">
        <div class="day-view-grid value-3">
          <app-skeleton class="placeholder" width="2rem"></app-skeleton>
          <app-skeleton class="placeholder" width="2rem"></app-skeleton>
          <app-skeleton class="placeholder" width="2rem"></app-skeleton>
          <app-skeleton
            class="placeholder"
            [centered]="true"
            width="1rem"
          ></app-skeleton>
          <app-skeleton class="placeholder" width="4rem"></app-skeleton>
        </div>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <!-- Duty period expansion panels -->
    <ng-template #dutyPeriodPanels>
      <mat-expansion-panel
        *ngFor="let dutyPeriod of sequence?.dutyPeriods"
        class="no-shadow dp-body"
        [disabled]="buttonClicked"
        (click)="buttonClicked = false"
        [expanded]="
          dutyPeriodExpansionState[dutyPeriod.dutyPeriodIndex] ||
          dutyPeriod.containsNextLeg
        "
        (opened)="onDutyPeriodExpanded(dutyPeriod.dutyPeriodIndex)"
        (closed)="onDutyPeriodClosed(dutyPeriod.dutyPeriodIndex)"
      >
        <mat-expansion-panel-header class="dp-panel-header">
          <div class="day-view-grid value-3">
            <div class="value-3">
              {{ dutyPeriod.dutyPeriodStartTime.toFormat("MM/dd") }}
            </div>

            <div class="value-2">
              {{
                dutyPeriod.dutyPeriodStartTime.toLocaleString(
                  DateTime.TIME_24_SIMPLE
                )
              }}
            </div>

            <div class="value-2">
              {{
                dutyPeriod.dutyPeriodEndTime.toLocaleString(
                  DateTime.TIME_24_SIMPLE
                )
              }}
            </div>

            <div class="value-3 text-center">
              {{ dutyPeriod.dutyPeriodLegs }}
            </div>

            <div
              *ngIf="dutyPeriod.layoverLength.as('minutes') > 0"
              class="layover-container"
            >
              <div
                matRipple
                class="text-button layover-city"
                (click)="onLayoverClick(dutyPeriod.dutyPeriodIndex, sequence)"
              >
                {{ dutyPeriod.layoverStation }}
              </div>

              <span class="layover-time value-3">{{
                dutyPeriod.layoverLength.toFormat("h:mm")
              }}</span>
            </div>
          </div>
        </mat-expansion-panel-header>

        <!-- ng-template lazy loads expansion panel content when panel is expanded. -->
        <ng-template matExpansionPanelContent>
          <div class="dp-container">
            <!-- Leg summary -->
            <app-leg-summary
              *ngFor="let leg of dutyPeriod.legs"
              [leg]="leg"
              [isLoading]="sequenceState.isLoading && !sequenceState.response"
              [isFlightDetailView]="false"
              class="box-shadow dark-theme-lighter-bg leg-summary thin-blue-border"
              [class.is-complete]="leg.depTimeActual && !leg.isDepEstimated"
            ></app-leg-summary>

            <!-- Duty period duty summary -->
            <app-data-box
              headerTitle="Duty"
              iconName="schedule"
              [dataItems]="dutyPeriod.dutyPeriodSummaryItems"
              [helpComponent]="dutyInfoDialogComponent"
              class="duty-period-totals"
            ></app-data-box>

            <!-- Duty period pay summary -->
            <app-data-box
              headerTitle="Pay"
              iconName="paid"
              [dataItems]="dutyPeriod.dutyPeriodPayItems"
              [helpComponent]="payInfoDialogComponent"
              class="pay-totals"
            ></app-data-box>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </ng-template>

    <!-- Sequence totals -->
    <app-data-box
      *ngIf="sequence"
      headerTitle="Sequence Totals"
      iconName="summarize"
      [dataItems]="sequence.sequenceSummaryItems"
      [helpComponent]="seqTotalDialogComponent"
      class="sequence-totals"
    ></app-data-box>
  </div>
  <div *ngIf="sequenceState.hasError" class="unavailable">
    <div class="text-center">Sequence data unavailable</div>
  </div>
  <div class="data-status">
    <app-data-status
      [timestamp]="sequenceState.response?.timestamp"
      [isLoading]="sequenceState.isLoading && !sequenceState.response"
      (refresh)="onRefreshClick()"
    ></app-data-status>
  </div>
  <mat-progress-bar
    *ngIf="sequenceState.isLoading"
    color="accent"
    mode="indeterminate"
  ></mat-progress-bar>
</mat-card>

